<template>
  <div style="width: 100%">
    <v-card>
      <v-card-title>
        <h3 class="headline mt-0">{{ $t('Add/Remove to cart') }}</h3>
      </v-card-title>
      <v-card-text>
        <label>{{ $t('Options') }}</label>
        <div class="form-control mb-4" :class="{ 'has-error': errors.has('method') }">
          <v-radio-group
            v-model="optype"
            v-validate="'required'"
            name="method"
            row
            :data-vv-as="$t('Options')"
            :error="errors.has('method')"
            :error-messages="errors.first('method')"
          >
            <v-radio color="primary" :value="'addtocart'" :label="$t('Add')"></v-radio>
            <v-radio color="primary" :value="'removetocart'" :label="$t('Remove')"></v-radio>
            <v-radio
              v-if="!isThailandPostMart"
              color="primary"
              :value="'removeandaddtocart'"
              :label="$t('Clear&Add')"
            ></v-radio>
          </v-radio-group>
          <!-- <span class="text-error" v-if="errors.has('method')">{{ errors.first('method') }}</span> -->
        </div>
        <div v-for="(item, k) in items" :key="k">
          <v-card>
            <v-card-text style="position: relative">
              <div class="text-xs-right">
                <v-btn
                  small
                  icon
                  style="position: absolute; right: 0; top: 0"
                  @click="items.splice(k, 1)"
                >
                  <span class="material-icons">delete_outline</span>
                </v-btn>
              </div>
              <div :style="{ 'min-height': expandForSelect === k ? '300px' : '' }">
                <div class="form-control" :class="{ 'has-error': errors.has('product') }">
                  <label>{{ $t('Products') }}</label>
                  <template v-if="isThailandPostMart">
                    <multiselect
                      v-model="items[k]"
                      v-validate="'required'"
                      internal-search
                      :data-vv-as="$t('Product')"
                      :placeholder="$t('Select Product')"
                      name="product"
                      :options="filterProducts"
                      track-by="sku"
                      label="product_title"
                      :max-height="250"
                      :open-direction="'below'"
                      :close-on-select="true"
                      @select="onThailandPostMartProductSelect(k)"
                      @open="expandForSelect = k"
                      @close="expandForSelect = ''"
                      @search-change="debounceSearch"
                    ></multiselect>
                  </template>
                  <multiselect
                    v-else
                    v-model="item.pid"
                    v-validate="'required'"
                    :data-vv-as="$t('Product')"
                    :placeholder="$t('Select Product')"
                    name="product"
                    :options="filterProducts"
                    return="id"
                    label="name"
                    :max-height="250"
                    :open-direction="'below'"
                    :close-on-select="true"
                    @select="onSelectedProduct(k)"
                    @open="expandForSelect = k"
                    @close="expandForSelect = ''"
                  ></multiselect>
                  <span v-if="errors.has('product')" class="text-error">{{
                    errors.first('product')
                  }}</span>
                </div>
                <v-layout row rows wrap>
                  <v-flex v-if="!isThailandPostMart" xs12 lg7 style="padding-right: 5px">
                    <div class="form-control" :class="{ 'has-error': errors.has('option') }">
                      <label>{{ $t('stock') }}</label>
                      <multiselect
                        v-model="item.option"
                        v-validate="'required'"
                        name="option"
                        :data-vv-as="$t('Options')"
                        :options="$options.filters.filteredStock(item)"
                        :placeholder="$t('Select Stock')"
                        :max-height="250"
                        :open-direction="'below'"
                        :close-on-select="true"
                        @open="expandForSelect = k"
                        @close="expandForSelect = false"
                      ></multiselect>
                      <span v-if="errors.has('option')" class="text-error">{{
                        errors.first('option')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 lg3>
                    <div class="form-control" :class="{ 'has-error': errors.has('quantity') }">
                      <label>{{ $t('quantity') }}</label>
                      <input
                        v-if="isThailandPostMart"
                        v-model="item.quantity"
                        v-validate="'required'"
                        type="text"
                        name="quantity"
                        :data-vv-as="$t('quantity')"
                        @keypress="isNumber($event, item.quantity)"
                      />
                      <input
                        v-else
                        v-model="item.qty"
                        v-validate="'required'"
                        type="text"
                        name="quantity"
                        :data-vv-as="$t('quantity')"
                        @keypress="isNumber($event, item.qty)"
                      />
                      <span v-if="errors.has('quantity')" class="text-error">{{
                        errors.first('quantity')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex v-if="$store.getters.getPackage == 'premium'" lg2>
                    <IntentPrefillCartAddRemove
                      @show=";['Number']"
                      @onAddPrefill="onAddPrefill($event, item)"
                    ></IntentPrefillCartAddRemove>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div class="text-xs-center my-3">
          <v-btn flat color="green" @click="additem">
            <span class="material-icons">add</span>
            {{ $t('Add product') }}
          </v-btn>
        </div>

        <!-- <template v-if="$route.name == 'Comment to inbox' && optype == 'addtocart'">
          <v-divider />
          <h3 class="headline">{{ $t('Limit reply to inbox') }}</h3>
          <v-checkbox
            v-model="checkstock"
            color="primary"
            :label="$t('Reply to inbox depends on stock')"
            hide-details
            @change="changecheckstock"
          ></v-checkbox>
          <div class="ml-4 pl-2">
            <v-checkbox
              v-model="adjuststock"
              color="primary"
              :label="$t('Real-time inventory after reply to inbox')"
              hide-details
              :disabled="checkstock == false"
            ></v-checkbox>
          </div>
          <v-divider class="my-4" />
          <v-checkbox
            v-model="checksameproductincarts"
            color="primary"
            :label="$t('Refusing to reply users who has product(s) in the cart')"
            hide-details
          ></v-checkbox>
        </template> -->
        <div class="text-xs-center mt-2">
          <v-btn outline color="grey" @click="close">CANCEL</v-btn>

          <v-btn v-if="data" depressed color="primary" @click="update">UPDATE</v-btn>
          <v-btn v-else depressed color="primary" @click="save">SAVE</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import IntentPrefillCartAddRemove from '@/components/elements/IntentPrefillCartAddRemove.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import api from '@/api'
import { debounce } from 'lodash'

export default {
  components: {
    multiselect,
    IntentPrefillCartAddRemove
  },
  props: ['data'],
  data() {
    return {
      optype: '',
      loading: false,
      expandForSelect: false,
      items: [
        {
          qty: '',
          pid: '',
          option: ''
        }
      ],
      checkstock: false,
      checksameproductincarts: false,
      adjuststock: false,
      thailandpostmartItems: [
        {
          sku: ''
        }
      ],
      thailandpostmartOptions: [],
      productSearch: [],
      debounceSearch: undefined
    }
  },
  created() {
    this.debounceSearch = debounce((searchText) => {
      if (searchText) {
        this.handleSearch(searchText)
      } else {
        this.productSearch = this.products
      }
    }, 300)
  },
  mounted() {
    if (this.data) {
      this.optype = this.data.type
      this.product = this.products.filter((el) => el.id == this.data.pid)[0]
      this.items = this.data.input
      if (!this.isThailandPostMart) {
        this.items = this.items.map((el) => {
          return { ...el, pid: this.products.find((val) => val.id == el.pid) }
        })
      }
      this.checksameproductincarts = this.data.hasOwnProperty('checksameproductincarts')
        ? this.data.checksameproductincarts
        : false
      this.checkstock = this.data.hasOwnProperty('checkstock') ? this.data.checkstock : false
      this.adjuststock = this.data.hasOwnProperty('adjuststock') ? this.data.adjuststock : false
    }
  },
  computed: {
    filterProducts() {
      return this.productSearch.length > 0 ? this.productSearch : this.products
    },
    // filterStocks() {
    //   if (this.product) {
    //     return this.product.productstock.map(el => el[1])
    //   } else {
    //     return []
    //   }
    // },
    ...mapGetters({ selectedBot: 'selectedBot', products: 'getProducts' }),
    isThailandPostMart() {
      return ['thailandpostmart'].includes(this.selectedBot.type)
    }
  },
  methods: {
    changecheckstock(value) {
      if (!value) {
        this.adjuststock = false
      }
    },
    isNumber: function (evt, qty) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) ||
        !/^[0-9]*$/gm.test(qty)
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onAddPrefill(v, item) {
      item.qty = v
    },
    additem() {
      this.items.push({
        option: '',
        pid: '',
        qty: ''
      })
    },
    update() {
      if (this.isThailandPostMart) {
        this.$emit('updateRemoveAndAdd', {
          type: this.optype,
          data: this.items,
          index: this.data.index,
          checkstock: this.optype == 'addtocart' ? this.checkstock : false,
          checksameproductincarts:
            this.optype == 'addtocart' ? this.checksameproductincarts : false,
          adjuststock: this.optype == 'addtocart' ? this.adjuststock : false
        })
      } else {
        var data = this.items.map((el) => {
          return { pid: el.pid.id, qty: el.qty, option: el.option }
        })
        this.$emit('updateRemoveAndAdd', {
          type: this.optype,
          data: data,
          index: this.data.index,
          checkstock: this.optype == 'addtocart' ? this.checkstock : false,
          checksameproductincarts:
            this.optype == 'addtocart' ? this.checksameproductincarts : false,
          adjuststock: this.optype == 'addtocart' ? this.adjuststock : false
        })
      }

      this.close()
    },
    close() {
      this.optype = ''
      this.stock = ''
      this.product = ''
      this.quantity = ''
      this.$emit('close')
    },
    save() {
      var vm = this
      // var data = {
      //   pid: this.product.id,
      //   qty: this.quantity,
      //   option: this.stock
      // }
      this.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          reject()
          return false
        }

        let data

        if (this.isThailandPostMart) {
          data = vm.items
        } else {
          data = vm.items.map((el) => {
            return { pid: el.pid.id, qty: el.qty, option: el.option }
          })
        }

        vm.$emit('addIntentItem', vm.optype, {
          obj: data,
          checkstock: this.optype == 'addtocart' ? vm.checkstock : false,
          checksameproductincarts: this.optype == 'addtocart' ? vm.checksameproductincarts : false,
          adjuststock: this.optype == 'addtocart' ? vm.adjuststock : false
        })

        vm.close()
      })
    },
    onSelectedProduct(k) {
      this.items[k].option = ''
    },
    onThailandPostMartProductSelect(k) {
      this.$nextTick(() => {
        this.items[k].quantity = ''
      })
    },
    handleSearch(searchText) {
      const vm = this
      if (vm.selectedBot.type == 'thailandpostmart') {
        if (searchText) {
          return new Promise((resolve, reject) => {
            if (!vm.selectedBot) {
              reject()
            }
            let data = {
              slug: 'all',
              pageid: vm.selectedBot.pageid,
              search: searchText
            }
            if (searchText && searchText.trim()) data.search = searchText.trim()
            api.getProductBySlugThailandPostmart(data, function (error, response) {
              if (error) {
                resolve()
                return
              }
              if (response.data.length > 0) {
                vm.productSearch = []
                vm.productSearch = response.data
              } else {
                vm.productSearch = this.products
              }
              resolve()
            })
          })
        } else {
          vm.productSearch = []
        }
      }
    }
  },
  filters: {
    filteredStock: function (value) {
      if (value && value.pid) {
        return value.pid.productstock.map((el) => el[1])
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentCartAddRemove.vue